// draggable.js
export default {
  // 定义 Vue 插件
  install(Vue) {
    // 在你的Vue组件中
    Vue.directive('draggable', {
      bind(el, binding, vnode) {
        let dragging = false;
        let startX, startY, offsetX, offsetY, startWidth, startHeight;
        el.style.position = 'absolute';
        el.style.cursor = 'move';
        el.addEventListener('mousedown', function(e) {
          if(e.target.className!=='header' && e.target.className!=='form-header-box'){
            el.style.cursor = 'unset';
            return false
          }
          el.style.cursor = 'move';
          dragging = true;
          startX = e.clientX;
          startY = e.clientY;
          offsetX = el.offsetLeft;
          offsetY = el.offsetTop;

          startWidth = el.offsetWidth;
          startHeight = el.offsetHeight;
        });
        document.addEventListener('mousemove', function(e) {
          if (dragging) {
            const dx = e.clientX - startX;
            const dy = e.clientY - startY;
            el.style.left = offsetX + dx + 'px';
            el.style.top = offsetY + dy + 'px';
            el.style.width = startWidth + 'px';
            el.style.height = startHeight + 'px';
          }
        });
        document.addEventListener('mouseup', function() {
          dragging = false;
          document.body.style.cursor = 'default';
        });
      }
    });
  }
}
